export default {
    General: 'General',
    JWTAuth: 'JWTAuth',
    StudentsAPIRequest: 'StudentsAPIRequest',
    SLRequest: 'SLRequest'
};